import { LiteTradeNotificationCloseAllStyled } from './styled/LiteTradeNotificationCloseAllStyled';
import { useLangContext } from '../../../../providers/LangProvider/LangProviderContext';
import BinIcon from '../../../../components/icon/IconWrapped';
import { useEffect } from 'react';
import { useDispatch } from 'react-redux';
import { animationSlice } from '../../../Animation/animationReducer';
import { ANIMATION_EVENT_NAMES } from '../../../Animation/animationConstants';

interface ILiteTradeNotificationCloseAllProps {
    sumPl: number;
}

function LiteTradeNotificationCloseAll(props: ILiteTradeNotificationCloseAllProps) {
    const { sumPl } = props;
    const { getLangPath } = useLangContext();
    const dispatch = useDispatch();

    useEffect(() => {
        if (sumPl > 0) {
            dispatch(animationSlice.actions.setIsShowAnimationOnEventAction({
                eventName: ANIMATION_EVENT_NAMES.CLOSE_ALL,
                isShow: true,
            }));
        }
    }, [dispatch, sumPl]);

    return <LiteTradeNotificationCloseAllStyled>
        <BinIcon name={'IcCheckCircle'} size={40}/>
        <span>{getLangPath('lite_version.notifications.close_all_description')}</span>
    </LiteTradeNotificationCloseAllStyled>;
}

export default LiteTradeNotificationCloseAll;
